<template>
    <b-form-group :label="label"
                  :invalid-feedback="errorTxt"
                  :state="state">
        <template #label>
            {{label}} <span v-if="required" class="text-danger">*</span>
        </template>
        <div class="row">
            <div class="col-md-10"><post-select :model="newItem" attribute="post_id" :filter="{page: 'main', status: 'public', category_id: this.category_id}" /></div>
            <div class="col-md">                
                <button :disabled="loading" type="button" class="btn btn-sm btn-outline-gray" @click="addNewItem">
                    <b-spinner v-if="loading" small></b-spinner>
                    <i class="fa fa-plus" v-else></i>
                    Chọn
                </button>
            </div>
        </div>

        <div class="bs-component">
            <ul class="list-group">
                <draggable v-model="inputVal" :state="state" :readonly="readonly">
                    <li class="list-group-item" v-for="(item, index) in inputVal" :key="index" style="cursor: move">
                        <div class='row'>
                            <div class='col-md-8'>
                                <i class="fa fa-angle-right mt-2"></i>
                                <span v-if="items.find(i => i.id=== item)"> {{items.find(i => i.id=== item).title}}</span>
                                <span v-else> #{{item}}</span>
                            </div>
                            <div class='col-md-2 text-center mt-2'>
                                <span v-if="items.find(i => i.id=== item) && items.find(i => i.id=== item).status == 'private'" class="badge bg-secondary ml-1" > Bản nháp  </span>
                                <span v-else class="badge bg-success ml-1" >Công khai </span>
                            </div>
                            <div class='col-md-2 text-right'>
                                <button type="button" class="btn-sm btn btn-sm btn-outline-gray mr-1">
                                    <i class="fa fa-arrows-alt mr-0"></i>
                                </button>
                                <button @click="removeItem(index)" type="button" class="btn-sm btn btn-sm btn-outline-danger">
                                    <i class="fa fa-trash-alt mr-0"></i>
                                </button>
                            </div>
                        </div>
                    </li>
                </draggable>
            </ul>
        </div>
    </b-form-group>
</template>

<script>
    import draggable from 'vuedraggable';
    import PostSelect from '@/components/PostSelect';

    export default {
        components: {draggable, PostSelect},
        props: ['model', 'attribute', 'label', 'type', 'placeholder', 'errors', 'readonly', 'errorOnly', 'required', 'category_id'],
        data() {
            return {
                items: [],
                inputVal: this.model[this.attribute] ? this.model[this.attribute] : null,
                state: null,
                errorTxt: '',
                newItem: {post_id: null},
                loading: false
            }
            
        },
        watch: {
            model: {
                handler(val) {
                    this.state = null;
                    this.errorTxt = '';
                    this.inputVal = val[this.attribute];
                }, deep: true
            },
            inputVal(val) {
                this.state = null;
                this.errorTxt = '';
                this.model[this.attribute] = val;
            },
            errors(val) {
                let hasErr = false;
                if (val && Object.keys(val).length) {
                    Object.keys(val).forEach(key => {
                        if (key === this.attribute) {
                            this.state = false;
                            this.errorTxt = val[key].join(";");
                            hasErr = true;
                        }
                    });
                }
                if (!this.errorOnly) {
                    this.state = !hasErr;
                }
            }
        },
        methods: {
            load() {
                if (this.model[this.attribute]) {
                    this.inputVal = this.model[this.attribute];
                    let ids = this.model[this.attribute].join(',');
                    if (ids) {
                        this.loading = true;
                        this.$service.get(`post/gets`, {
                            params: {ids: ids}
                        }).then(response => {
                            this.items = response.data;
                        }).finally(() => {
                            this.loading = false;
                        });
                    } else {
                        this.items = [];
                    }
                }
            },
            addNewItem: function () {
                if (!this.newItem.post_id) {
                    this.$swal({
                        text: "Vui lòng chọn bài viết",
                        icon: 'warning',
                        toast: true,
                        position: 'bottom-end',
                        timer: 3000,
                    });
                    return false;
                }

                if (this.model[this.attribute] === null) {
                    this.model[this.attribute] = [];
                }

                let cf = this.model[this.attribute].find(item => {
                    return item === this.newItem.post_id;
                });
                if (typeof (cf) !== 'undefined') {
                    this.newItem = {post_id: null};
                } else if (this.newItem) {
                    this.model[this.attribute].push(this.newItem.post_id);
                    this.newItem = {post_id: null};
                }
                this.load();
            },
            newItemEnter: function (e) {
                if (e.keyCode === 13) {
                    this.addNewItem();
                }
            },
            removeItem: function (index) {
                if (this.model[this.attribute] && this.model[this.attribute].length) {
                    this.model[this.attribute].splice(index, 1);
                    this.inputVal = this.model[this.attribute];
                    this.load();
                }
            }
        },
        mounted() {
            this.load();
        }
    }
</script>